import i18next from 'i18next';

i18next.addResources('es', 'ChangeWorkspaceError', {
  title: 'NO SE PUDO CAMBIAR SU ESPACIO DE TRABAJO',
  subtitle: 'Su espacio de trabajo actual es:',
  body: 'Para poder cambiar su espacio de trabajo, primero debe transferir el rol de Dueño a otro miembro de este espacio.',
  transferRole: 'Transferir rol'
});
